<div id="modalContent" [ngClass]="{ xSmallScreen: xSmallScreen }">
  <div class="header">
    <h2 translate>watch.playlist_modal.create_new_playlist_modal.title</h2>
  </div>

  <div class="content">
    <div class="wrapper">
      <div class="label" translate>
        watch.playlist_modal.create_new_playlist_modal.labels.name
        <span class="required">*</span>
      </div>

      <div class="input-wrapper">
        <span class="icon icon-video-playlist"></span>
        <input
          class="input"
          type="text"
          name="name"
          id="name"
          [placeholder]="
            getTranslation(
              'watch.playlist_modal.create_new_playlist_modal.tips.name'
            )
          "
          [(ngModel)]="name" />
      </div>
    </div>
    <div class="wrapper">
      <div class="label" translate>
        watch.playlist_modal.create_new_playlist_modal.labels.desc
      </div>

      <ckeditor
        class="ckdata"
        [(ngModel)]="desc"
        [editor]="editor"
        [config]="config" />
    </div>
    <div class="wrapper">
      <div class="label-wrapper">
        <div class="label" translate>
          watch.playlist_modal.create_new_playlist_modal.labels.public
        </div>

        <div
          class="switch"
          (click)="switchClick()"
          [ngClass]="isPublic ? 'yes' : 'no'">
          <div class="circle" [ngClass]="isPublic ? 'right' : 'left'"></div>
          @if (isPublic) {
            <ng-container>
              <div class="txt-left">yes</div>
            </ng-container>
          } @else {
            <ng-template>
              <div class="txt-right">no</div>
            </ng-template>
          }
        </div>
      </div>
      <div class="hint" translate>
        watch.playlist_modal.create_new_playlist_modal.tips.public
      </div>
    </div>

    <div class="divider"></div>

    <div class="public-block-wrapper">
      <div class="public-block">
        @if (isPublic) {
          <div class="label" translate>
            watch.playlist_modal.create_new_playlist_modal.labels.banner
            <span class="required"> * </span>
          </div>
        }
        <div class="img-placeholder">
          @if (bannerSrc && bannerFile) {
            <img [src]="bannerSrc" />
            <div class="remove" (click)="remove('banner')">
              <kin-icon name="trash" [color]="trashColor"></kin-icon>
            </div>
          }
          <input
            #inputBanner
            class="inputfile"
            id="bannerFile"
            type="file"
            (change)="loadImage($event, 'banner')"
            accept="image/jpeg, image/png" />

          @if (bannerFile == null) {
            <label for="bannerFile" translate>
              <span class="icon icon-plus-lg"></span>
              watch.playlist_modal.create_new_playlist_modal.btn.banner
            </label>
          } @else if (!logoSrc) {
            <div class="file-name">{{ bannerFile.name }}</div>
          }
        </div>
      </div>

      <div class="public-block">
        @if (isPublic) {
          <div class="label" translate>
            watch.playlist_modal.create_new_playlist_modal.labels.logo
            <span class="required">*</span>
          </div>
        }
        <div class="logo-wrapper">
          <div class="img-placeholder logo">
            @if (logoSrc && logoFile) {
              <img [src]="logoSrc" />
              <div class="remove" (click)="remove('logo')">
                <kin-icon name="trash" [color]="trashColor"></kin-icon>
              </div>
            }
            <input
              #inputLogo
              class="inputfile"
              id="logoFile"
              type="file"
              (change)="loadImage($event, 'logo')"
              accept="image/jpeg, image/png" />
            @if (logoFile == null) {
              <label for="logoFile" translate>
                <span class="icon icon-plus-lg"></span>
              </label>
            } @else if (!logoSrc) {
              <div class="file-name">{{ logoFile.name }}</div>
            }
          </div>
          <p class="hint" translate>
            watch.playlist_modal.create_new_playlist_modal.tips.logo
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <div
      [ngClass]="
        (!isPublic && name !== '') ||
        (isPublic && logoFile && bannerFile && name !== '')
          ? 'submit-btn'
          : 'submit-btn-disabled'
      "
      (click)="sendPlaylist()"
      pRipple
      translate>
      watch.playlist_modal.add_to_playlist_modal.btn
    </div>
  </div>
</div>
